import { render, staticRenderFns } from "./Buyers.vue?vue&type=template&id=8cc0688a&scoped=true&"
import script from "./Buyers.vue?vue&type=script&lang=ts&"
export * from "./Buyers.vue?vue&type=script&lang=ts&"
import style0 from "./Buyers.vue?vue&type=style&index=0&id=8cc0688a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc0688a",
  null
  
)

export default component.exports